//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import { ProductDetailsFieldLabels } from '@campaigns/components/shared/product-details-modal/drawer/constants/ProductDetailsModalFieldLabels';
import { FormField } from '@campaigns/components/shared/product-details-modal/drawer/form/FormField';

interface ProductDescriptionFieldProps {
  isViewOnly: boolean;
}

export const ProductDescriptionField = ({
  isViewOnly,
}: ProductDescriptionFieldProps) => {
  return (
    <FormField
      inputType='textarea'
      isViewOnly={isViewOnly}
      label={ProductDetailsFieldLabels.description}
      labelHelpText='Enter at least two sentences describing the features, benefits, and uses of the product.'
      name='description'
      placeholder=''
      rules={{
        required: {
          value: true,
          message: 'Please enter a product description',
        },
      }}
    />
  );
};
